import { fetchWithFallback } from "../OrgUsageAnalytics/api";

const BASE = "/integrations/encompass";

// The organizations configured for Encompass Partner Connect. One connected
// only through the older credential-based integration has no EPC token and is
// not listed by the backend; it is still reachable by pasting its id.
export async function listEncompassOrganizations(env, params = {}) {
  return fetchWithFallback(`${BASE}/organizations`, params, { env });
}

// Everyone who matters to the integration, one row each: the owner and every
// accepted member with how many loans they are on and what they can open, plus
// the organization's own default and its auto-sync state. Runs one count per
// person, so it is loaded on demand rather than with the org list.
export async function listEncompassPeople(env, organizationId) {
  return fetchWithFallback(
    `${BASE}/organizations/${organizationId}/people`,
    {},
    { env },
  );
}

// Read-only: why one person can or cannot open one loan, using the verdict the
// loan board itself applies. `loan` is an Addy loan id, a lender loan number or
// an Encompass id.
export async function explainEncompassAccess(
  env,
  organizationId,
  { subjectType, memberId, loan },
) {
  return fetchWithFallback(
    `${BASE}/organizations/${organizationId}/explain-access`,
    { subjectType, ...(memberId ? { memberId } : {}), loan },
    { env },
  );
}

// Sets what one person may open. Body: { organizationId, subjectType,
// memberId?, selection } — "all_loans", "own_loans", or null to return them to
// the organization's default.
export async function setEncompassVisibility(env, body) {
  return fetchWithFallback(
    `${BASE}/set-visibility`,
    {},
    { env, method: "POST", body },
  );
}

// Sets what everyone with no decision of their own gets. Body:
// { organizationId, loanVisibilityDefault: "follow_addy_role"|"own_loans" }.
// Narrowing takes effect immediately for everyone undecided; the response says
// how many people that is.
export async function setEncompassVisibilityDefault(env, body) {
  return fetchWithFallback(
    `${BASE}/loan-visibility-default`,
    {},
    { env, method: "POST", body },
  );
}

// Turns the Automated Service Ordering feed on or off. Body:
// { organizationId, enabled }. Widens what ARRIVES, never what anyone sees.
export async function setEncompassAutoSync(env, body) {
  return fetchWithFallback(
    `${BASE}/auto-sync`,
    {},
    { env, method: "POST", body },
  );
}
